import script from "./bannerBox.vue?vue&type=script&setup=true&lang=js"
export * from "./bannerBox.vue?vue&type=script&setup=true&lang=js"

import "./bannerBox.vue?vue&type=style&index=0&id=51e4c86e&lang=scss&scoped=true"

import exportComponent from "C:\\develop\\workspace_cursor\\weiquyun\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e4c86e"]])

export default __exports__